import { render, staticRenderFns } from "./Actualite.vue?vue&type=template&id=92574136"
import script from "./Actualite.vue?vue&type=script&lang=ts"
export * from "./Actualite.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports